import { useMissionsTranslation } from '../../../../../ui/hooks';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
export const ToolbarAdmin = ({ participantNumber, totalRequiredParticipantNumber, multiSelect, actions }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(Box, { sx: {
            display: 'flex',
            pb: 2,
            alignItems: { xs: 'flex-start', md: 'center' },
            flexWrap: 'wrap',
            gap: 1,
        }, "data-test": 'shift-roster-toolbar' },
        React.createElement(Box, { display: 'flex', flexGrow: 1, gap: 1 },
            React.createElement(Box, { display: 'flex', alignItems: 'center', gap: 1 },
                React.createElement(SupervisorAccountOutlinedIcon, { sx: { color: (theme) => theme.palette.grey['700'] } }),
                React.createElement(Typography, { variant: 'subtitle2', sx: { color: (theme) => theme.palette.grey['900'] } }, t('missions.missionDetails.shiftRoster')),
                React.createElement(Typography, { variant: 'body2', sx: { color: (theme) => theme.palette.grey['700'] } },
                    "(",
                    `${participantNumber} of ${totalRequiredParticipantNumber}`,
                    ")")),
            participantNumber > 0 && (React.createElement(Button, { size: 'small', onClick: multiSelect.handleSelectAllRows, "data-test": 'select-all-button' }, multiSelect.allItemsSelected ? t('common.unselectAll') : t('common.selectAll')))),
        actions));
};
